import { CategoryManager } from './categoryManager';

export interface Vendor {
  name?: string;
  number?: number;
  numberString?: string;
  selectedBoothId?: number;

  categoryManagers?: CategoryManager[];

  //kvp list of booth Id and name
  boothsDropdown?: BoothIdName[];
  boothDropdownLoading?: boolean;
  hasPrograms?: boolean;
}

export interface BoothIdName {
  boothId: number;
  name: string;
}

export function isVendor(arg: any): arg is Vendor {
  return arg && arg.number;
}

export const initialVendor: Vendor = {
  name: 'NO Vendor',
  number: 0,
  numberString: '0',
  boothDropdownLoading: false,
  categoryManagers: [],
};
